import { v4 as uuid } from 'uuid';
import { useMemo } from 'react';

export function useUUID() {
  return useMemo(() => uuid(), []);
}
